import { render, staticRenderFns } from "./PackageInfo.vue?vue&type=template&id=3868b9ee&scoped=true&"
import script from "./PackageInfo.vue?vue&type=script&lang=js&"
export * from "./PackageInfo.vue?vue&type=script&lang=js&"
import style0 from "./PackageInfo.vue?vue&type=style&index=0&id=3868b9ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3868b9ee",
  null
  
)

export default component.exports